export const GET_SUBJECT_START = "GET_SUBJECT_START"
export const GET_SUBJECT_SUCCESS = "GET_SUBJECT_SUCCESS"
export const GET_SUBJECT_FAILED = "GET_SUBJECT_FAILED"

export const SUBMIT_REQUEST_START = "SUBMIT_REQUEST_START"
export const SUBMIT_REQUEST_SUCCESS = "SUBMIT_REQUEST_SUCCESS"
export const SUBMIT_REQUEST_FAILED = "SUBMIT_REQUEST_FAILED"